export const watermarkPath = (channel: number) => `/v4/admin/watermarks/${channel}`;
